import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@cotera/client/v0/lib/utils';

const shimmerTextVariants = cva(
  'inline-block bg-gradient-to-r bg-[length:200%_100%] bg-clip-text text-transparent animate-shimmer text-sm',
  {
    variants: {
      variant: {
        default: 'from-blue-600 via-blue-400 to-blue-600',
        muted: 'from-gray-600 via-gray-400 to-gray-600',
        warning: 'from-amber-600 via-amber-500 to-amber-600',
        sidebar: 'from-slate-500 via-indigo-400 to-slate-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export type ShimmerTextProps = React.ComponentProps<'span'> &
  VariantProps<typeof shimmerTextVariants>;

export const ShimmerText: React.FC<ShimmerTextProps> = ({
  children,
  className,
  variant,
  ...props
}) => {
  return (
    <span
      className={cn(shimmerTextVariants({ variant }), className)}
      {...props}
    >
      {children}
    </span>
  );
};

export { shimmerTextVariants };
